/** 各フェーズ定義 */
export const PHASE = {
  STANDBY_ENGINE_START: "standbyEngineStart", // エンジン始動指示
  STANDBY_FORCED_PLAYBACK: "standbyForcedPlayback", // GPF強制再生確認表示
  STANDBY_PLAYBACK: "standbyPlayback", // GPF再生確認表示
  EXECUTION: "execution", // 実行
  EXECUTION_MONITORING_STATUS: "executionMonitoringStatus", // GPF再生状態確認
  EXECUTION_MONITORING_CANCEL: "executionMonitoringCancel", // GPF再生中止確認表示
  COOLING_DISPLAY: "coolingDisplay", // 冷却中表示
  IGOFF_INSTRUCTION_DISPLAY: "igOffInstructionDisplay", // IGOFF指示表示
  IGOFF_STANDBY: "igOffStandby", // IGOFF待機
  SUCCESS: "success", // 完了表示(通常監視)
  COOLING_COMPLETED: "coolingCompleted", // 完了表示(中断監視)
  START_CONDITION_ERROR: "startConditionError", // 開始条件不成立表示
  GPF_ERROR: "gpfError", // GPF再生異常表示
  COMMUNICATION_ERROR: "communicationError", // 通信エラー
  COMMON_ERROR: "commonError", // 共通エラー
};

/** 時間 */
export const TIME = {
  INITIAL_TIME_FOR_COOLING: 600000, // 冷却中表示の初期表示時間(10分)
  INITIAL_TIME_FOR_IGOFF: 15000, // IGOFF待機の初期表示時間(15秒)
  INTERVAL_FOR_COOLING: 60000, // 冷却中表示の更新間隔(60秒)
  INTERVAL_FOR_IGOFF: 1000, // IGOFF待機の更新間隔(1秒)
};

/** データ読出し結果 */
export const READ_RESULT_TYPE = {
  FORCE: "force",
  NORMAL: "normal",
  NG: "ng"
};